import { render, staticRenderFns } from "./SaggingTemplate.vue?vue&type=template&id=4577c52a"
import script from "./SaggingTemplate.vue?vue&type=script&lang=js"
export * from "./SaggingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports